import VueRouter, { RouteConfig } from 'vue-router'

const List = () => import('../views/rpe-test/List.vue')
const Edit = () => import('../views/rpe-test/Edit.vue')
const Landing = () => import('../views/rpe-test/Landing.vue')

const Stats = () => import('../views/rpe-test/Stats.vue')
const StatsClazz = () => import('../views/rpe-test/StatsClazz.vue')

export const listRoute: RouteConfig = {
  path: '/rpe-test-list',
  name: 'rpe_test_list',
  component: List,
  meta: {
    title: 'RPE测评',
  },
}

export const editRoute: RouteConfig = {
  path: '/rpe-test-edit',
  name: 'rpe_test_edit',
  component: Edit,
  meta: {
    title: '布置RPE测评',
  },
}

export const landingRoute: RouteConfig = {
  path: '/rpe-test-landing',
  name: 'rpe_test_landing',
  component: Landing,
  meta: {
    title: 'RPE测评',
  },
}

export const statsRoute: RouteConfig = {
  path: '/rpe-test-details',
  name: 'rpe_test_details',
  component: Stats,
  props: (route) => ({ ...route.query, ...route.params, showPoster: route.query.showPoster === '1' }),
  meta: {
    title: 'RPE测评详情',
  },
}

export const statsClazzRoute: RouteConfig = {
  path: '/rpe-test-details-clazz',
  name: 'rpe_test_details_clazz',
  component: StatsClazz,
  props: (route) => ({ ...route.query, ...route.params, clazzId: +route.query.clazzId }),
  meta: {
    title: 'RPE测评详情',
  },
}

export default [listRoute, editRoute, landingRoute, statsRoute, statsClazzRoute]

export function navigateToRPETestList(router: VueRouter) {
  router.push({ name: listRoute.name })
}

export function navigateToRPETestEdit(router: VueRouter) {
  router.push({ name: editRoute.name })
}

export function redirectToRPETestEdit(router: VueRouter) {
  router.replace({ name: editRoute.name })
}

export function navigateToRPETestLanding(router: VueRouter) {
  router.push({ name: landingRoute.name })
}

export function navigateToRPETestStats(router: VueRouter, id: string, showPoster?: number) {
  router.push({ name: statsRoute.name, query: { id, showPoster: showPoster ? `${showPoster}` : undefined } })
}

export function redirectToRPETestStats(router: VueRouter, id: string, showPoster?: number) {
  router.replace({ name: statsRoute.name, query: { id, showPoster: showPoster ? `${showPoster}` : undefined } })
}

export function navigateToRPETestStatsClazz(router: VueRouter, id: string, clazzId: number) {
  router.push({ name: statsClazzRoute.name, query: { id, clazzId: `${clazzId}` } })
}
